
export const availableModules = [
  {
    id: "setup",
    name: "Setup",
    description: "Core system configuration (mandatory for all customers)",
    enabled: true,
    isRequired: true
  },
  {
    id: "table-range",
    name: "Table Range",
    description: "Create and manage dynamic data tables with custom ranges",
    enabled: true
  },
  {
    id: "data-function",
    name: "Data Function",
    description: "Advanced data manipulation and transformation tools",
    enabled: true
  },
  {
    id: "suite-search",
    name: "Suite Search",
    description: "Powerful search functionality across all modules",
    enabled: true
  },
  {
    id: "template",
    name: "Template",
    description: "Create and manage reusable document templates",
    enabled: false
  },
  {
    id: "budget-upload",
    name: "Budget Upload",
    description: "Import budget data from external sources",
    enabled: true
  },
  {
    id: "banking",
    name: "Banking",
    description: "Financial transaction management and reconciliation",
    enabled: false
  },
  {
    id: "variable-list",
    name: "Variable List",
    description: "Define and manage custom variables for calculations",
    enabled: false
  },
  {
    id: "zero-suppression",
    name: "Zero Suppression",
    description: "Hide zero values in reports for cleaner data presentation",
    enabled: false
  },
  {
    id: "ai-assistant",
    name: "AI Assistant",
    description: "Intelligent assistance for data analysis and reporting",
    enabled: false
  },
  {
    id: "data-science",
    name: "Data Science",
    description: "Advanced analytics and machine learning capabilities",
    enabled: false
  }
];
